/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Prep_SubInputs */

const en_notify_prep_sub = /** @type {(inputs: Notify_Prep_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The evening before, when a recipe needs soaking, marinating or defrosting`)
};

const de_notify_prep_sub = /** @type {(inputs: Notify_Prep_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Vorabend, wenn ein Rezept Einweichen, Marinieren oder Auftauen braucht`)
};

/**
* | output |
* | --- |
* | "The evening before, when a recipe needs soaking, marinating or defrosting" |
*
* @param {Notify_Prep_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_prep_sub = /** @type {((inputs?: Notify_Prep_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Prep_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_prep_sub(inputs)
	return en_notify_prep_sub(inputs)
});